module.exports = __webpack_public_path__ + "assets/img/con7-bg.2fd61bfc.jpg";